import { Music4, Lock, RotateCcw, LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startOwnerLogin() {
  const redirectUrl = window.location.origin + "/owner";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export function StudioHeader({ codeStatus, onOpenCode, onReset, isOwner, ownerName, onOwnerNav }) {
  return (
    <header className="sticky top-0 z-30 border-b border-[#1E2C48] bg-[#070B14]/90 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#E6C66E] to-[#D4AF37] flex items-center justify-center shrink-0 shadow-[0_0_20px_rgba(212,175,55,0.35)]">
            <Music4 className="w-5 h-5 text-[#0B0E14]" strokeWidth={2.5} />
          </div>
          <div className="min-w-0">
            <h1 className="font-heading text-sm sm:text-lg font-extrabold tracking-tight text-slate-50 leading-none truncate">
              AI Song Prompt Studio
            </h1>
            <div className="flex items-center gap-2 mt-1">
              <span className="inline-flex items-center gap-1.5 text-[10px] sm:text-xs text-emerald-300/90">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
                Suno v6 Engine
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Link to="/" data-testid="generator-nav-home" className="hidden sm:inline text-sm font-medium text-slate-300 hover:text-[#22D3EE] transition-colors px-1">Home</Link>
          <Link to="/faq" data-testid="generator-nav-faq" className="hidden sm:inline text-sm font-medium text-slate-300 hover:text-[#22D3EE] transition-colors px-1 mr-1">FAQ</Link>
          {isOwner ? (
            <>
              <Badge
                data-testid="owner-badge"
                className="hidden sm:inline-flex bg-amber-500/15 text-amber-200 border border-amber-500/30"
              >
                Owner · {ownerName || "unlimited"}
              </Badge>
              <Button
                data-testid="owner-dashboard-toggle"
                onClick={onOwnerNav}
                size="sm"
                className="bg-[#121B30] border border-[#1E2C48] text-slate-100 hover:bg-[#1a2540] h-9"
              >
                <Lock className="w-4 h-4 sm:mr-1.5" />
                <span className="hidden sm:inline">Dashboard</span>
              </Button>
            </>
          ) : (
            <>
              <button
                data-testid="buyer-access-code-badge"
                onClick={onOpenCode}
                className={`inline-flex items-center gap-1.5 rounded-full px-3 h-9 text-xs font-semibold border transition-colors ${
                  codeStatus?.valid
                    ? "bg-emerald-500/10 text-emerald-200 border-emerald-500/30 hover:bg-emerald-500/20"
                    : "bg-amber-500/10 text-amber-200 border-amber-500/30 hover:bg-amber-500/20"
                }`}
              >
                {codeStatus?.valid
                  ? codeStatus.allowance_left === null
                    ? "Code active · ∞"
                    : `Code · ${codeStatus.allowance_left} left`
                  : "Enter access code"}
              </button>
              <Button
                data-testid="owner-google-login-button"
                onClick={startOwnerLogin}
                size="sm"
                variant="ghost"
                className="text-slate-300 hover:text-amber-200 hover:bg-transparent h-9 px-2"
                title="Owner sign in"
              >
                <LogIn className="w-4 h-4" />
              </Button>
            </>
          )}
          <Button
            data-testid="reset-custom-button"
            onClick={onReset}
            size="sm"
            variant="ghost"
            className="text-slate-400 hover:text-slate-100 hover:bg-transparent h-9 px-2"
            title="Reset to custom"
          >
            <RotateCcw className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </header>
  );
}

export { startOwnerLogin };
